<template>
  <Header class="app-header">
    <a href="/" target="_self" class="app-header__logo" v-show="appBreakpoint">
      <img src="@/assets/img/logo-mini.png" alt="">
    </a>
    <a @click="toggleCollapse" class="app-header__toggle-btn">
      <i class="iconfont icon-outdent" v-if="!isCollapsed && !appBreakpoint" />
      <i class="iconfont icon-indent" v-else />
    </a>
    <div class="app-header__welcome">
      <ul>      
        <li>
          <Dropdown @on-click="userFun">
            <a href="javascript:void(0)" class="avatar">
              <Icon type="md-contact" />
              <span style="color: #67757c;">{{username}}</span>
            </a>
            <DropdownMenu slot="list">
              <DropdownItem name="logout"><Icon custom="iconfont iconlogout" /> 退出</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </li>
      </ul>
    </div>
    <Drawer placement="left" :closable="false" v-model="showDrawer" class="app-drawer">
      <AppMenu @selectMenu="selectMenu" />
    </Drawer>
  </Header>
</template>
<script>
import DataImport from '../statistics/DataImport'

export default {
  name: 'AppHeader',
  components: {
    DataImport
  },
  data () {
    return {
      showDrawer: false,
      dataImportDrawer: false
    }
  },
  computed: {
    username () {
      const userInfo = this.$store.state.userInfo
      return userInfo ? userInfo.name : ''
    },
    isCollapsed () {
      return this.$store.state.isCollapsed
    },
    appBreakpoint () {
      return this.$store.state.appBreakpoint
    }
  },
  methods: {
    toggleCollapse () {
      if (this.appBreakpoint) {
        this.showDrawer = true
      } else {
        this.$store.commit('updateCollapsed', !this.isCollapsed)
      }
    },
    selectMenu () {
      if (this.appBreakpoint) {
        this.showDrawer = false
      }
    },
    logout () {
      this.$Modal.confirm({
        title: '确认',
        content: '你确定需要退出吗？',
        onOk: () => {
          this.$store.dispatch('logout')
        }
      })
    },
    userFun (name) {
      if (name === 'logout') {
        this.logout()
      }
    },
    dataImport () {
      this.dataImportDrawer = true
    }
  }
}
</script>
<style lang="less">
  @import '../../assets/less/base/variables.less';
  .app-header {
    position: fixed;
    z-index: 4;
    left: 216px;
    top: 0;
    right: 0;
    min-width: 320px;
    padding: 0;
    transition: all @animation-time;
	background-color: white !important;
    box-shadow: 1px 0 7px rgba(0, 0, 0, 0.05);
    a {
      color: @text-color;
    }
    &__logo {
      width: 64px;
      text-align: center;
      display: block;
      float: left;
      transition: all @animation-time;
      img {
        width: 32px;
        display: inline-block;
        vertical-align: middle;
      }
    }
    &__toggle-btn {
      float: left;
      display: block;
      height: 56px;
      line-height: 56px;
      padding: 0 24px;
      cursor: pointer;
      transition: all @animation-time;
      &:hover {
        background: rgba(0,0,0,.035);
      }
      .iconfont {
        font-size: 22px;
      }
    }
    &__welcome {
      float:right;
      transition: all @animation-time;
      ul {
        display: flex;
        &.ivu-dropdown-menu {
          flex-direction: column;
        }
      }
      li {
        list-style: none;
      }
      a {
        display: block;
        padding: 0 12px;
        transition: all @animation-time;
        &:hover {
          background: rgba(0,0,0,.035);
        }
        span {
          margin-left: 8px;
        }
        &.avatar {
          .ivu-icon,
          .iconfont {
            font-size: 22px;
            color: @primary-color;
          }
          img {
            width: 24px;
            height: 24px;
            border-radius: 100%;
            display: inline-block;
            vertical-align: middle;
          }
        }
      }
      .iconfont,
      .ivu-icon {
        line-height: 1;
        vertical-align: middle;
        font-size: 18px;
        display: inline-block;
      }
    }
  }
  .app-drawer {
    .ivu-drawer-wrap {
      overflow: hidden;
    }
    .ivu-drawer-body {
      padding: 0;
      overflow: hidden;
    }
  }
</style>
